export enum ChannelType {
  InApp = 'in_app',
  Email = 'email',
  Sms = 'sms',
  Chat = 'chat',
  WebPush = 'web_push',
  MobilePush = 'mobile_push',
  Webhook = 'webhook',
}

export enum InAppActionType {
  Default = 'default',
  Single = 'single',
  Multi = 'multi',
}

export enum ContentType {
  Html = 'html',
  Plaintext = 'plaintext',
  Markdown = 'markdown',
  Json = 'json',
  Visual = 'visual',
}

export enum InterruptionLevel {
  Passive = 'passive',
  Active = 'active',
  TimeSensitive = 'time_sensitive',
  Critical = 'critical',
}

export enum PushPriority {
  Normal = 'normal',
  High = 'high',
}

export enum DeliveryStatus {
  Pending = 'pending',
  Sent = 'sent',
  Failed = 'failed',
}

export enum LogicNodeType {
  Digest = 'digest',
  Throttle = 'throttle',
  Wait = 'wait',
  Condition = 'condition',
}

export enum MemberRole {
  Owner = 'owner',
  Member = 'member',
}

export enum NotificationStatus {
  Pending = 'pending',
  Processing = 'processing',
  Processed = 'processed',
  Failed = 'failed',
}

export enum NotiflowNodeType {
  Trigger = 'trigger',
  End = 'end',
  Channel = 'channel',
  Digest = 'digest',
  Throttle = 'throttle',
  Wait = 'wait',
  Condition = 'condition',
}

export enum NotiflowRunStatus {
  Pending = 'pending',
  Running = 'running',
  Completed = 'completed',
  Failed = 'failed',
}

export enum NotiflowVersionStatus {
  Draft = 'draft',
  Published = 'published',
  Archived = 'archived',
}

export enum Provider {
  NotiflowsInApp = 'in_app',
  AmazonSes = 'ses',
  Sendgrid = 'sendgrid',
  Resend = 'resend',
  Mailgun = 'mailgun',
  Postmark = 'postmark',
  MailerSend = 'mailersend',
  SMTP = 'smtp',
  // Mailjet = 'Mailjet',
  // Mailtrap = 'Mailtrap',
  // Mandrill = 'Mandrill',
  // SparkPost = 'SparkPost',
  APNS = 'apns',
  FCM = 'fcm',
  // Expo = 'Expo',
  // OneSignal = 'OneSignal',
  // Pushpad = 'Pushpad',
  Twilio = 'twilio',
  SMSAPI = 'smsapi',
  // MessageBird = 'MessageBird',
  Slack = 'slack',
  WhatsApp = 'whatsapp',
  Telegram = 'telegram',
  Discord = 'discord',
  Webhook = 'webhook',
  WebPush = 'web_push',
}
